var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('iframe',{staticStyle:{"border":"0"},attrs:{"width":"100%","height":"1024","src":"https://datastudio.google.com/embed/u/0/reporting/2e982a26-4929-4f58-b2dd-fe8a7071b201/page/Q4tWB","frameborder":"0","allowfullscreen":""}})])
}]

export { render, staticRenderFns }